import script from "./employee-bulk-delete-confirm-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-bulk-delete-confirm-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-bulk-delete-confirm-modal.vue?vue&type=style&index=0&id=9e58ffaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e58ffaa"]])

export default __exports__